export { default } from './MarcadorMarato';
